import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { About } from "../components/About";
import { Areas } from "../components/Areas";
import { Resources } from "../components/Resources";
import { Journey } from "../components/Journey";
import { StudioOnline } from "../components/StudioOnline";
import { Faq } from "../components/Faq";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function HomePage() {
  return (
    <div className="bg-[#FBF9F5] text-[#1C1E1D] font-sans" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Areas />
        <Resources />
        <Journey />
        <StudioOnline />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
